import { makeStyles } from '@material-ui/core/styles';

export const useExchangeTitleStyles = makeStyles((theme) => ({
  points: {
    fontSize: 40,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  image: {
    height: 77,
    width: 156,
  },
  title: {
    fontSize: 20,
    color: '#464646',
  },
  subtitle: {
    fontSize: 16,
    color: '#464646',
  },
}));

export const useExchangeBodyStyles = makeStyles(() => ({
  container: {
    borderRadius: 10,
    border: '1px solid #BCBCBC',
    marginTop: 30,
    padding: 20,
    boxShadow: '0px 3px 6px #00000029',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginTop: 44,
  },
  subtitle: {
    fontSize: 16,
    color: '#464646',
    marginBottom: 20,
    textAlign: 'center',
  },
  button: {
    height: 40,
    width: 200,
    marginBottom: 44,
  },
  gitfCardDetail: {
    width: '100%',
    marginTop: 10,
  },
  divider: {
    '&.MuiDivider-root': {
      backgroundColor: '#ababab',
    },
    marginBottom: 20,
  },
  textToRight: {
    textAlign: 'right',
  },
  boxDesktop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '45px',
  },
  boxMobile: {
    display: 'grid',
    direction: 'column',
    rowGap: 20,
    '& > *': {
      marginBottom: 20,
      textAlign: 'center',
    },
  },
  lowerText: {
    fontSize: 12,
  },
}));

const carouselStyles = {
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
  '& .slick-disabled': {
    display: 'none !important',
  },
  '& .slick-next:focus': {
    color: '#424242 !important',
  },
  '& .slick-next:hover': {
    color: '#424242 !important',
  },
  '& .slick-prev:focus': {
    color: '#424242 !important',
  },
  '& .slick-prev:hover': {
    color: '#424242 !important',
  },
  '& .slick-track': {
    textAlign: 'center',
    margin: '0 auto',
  },
};

export const useCarouselStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '20px',
  },
  carousel: {
    ...carouselStyles,
  },
  carouselProducts: {
    ...carouselStyles,
    width: '75%',
  },
  carouselImgContainer: {
    width: (props) => (props.mobile ? '180px !important' : '270px !important'),
  },
  carouselImg: {
    width: 'inherit',
    height: 'inherit',
  },
  stock: {
    fontSize: 16,
    color: '#464646',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginTop: 20,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#464646',
  },
  imageMobile: {
    width: '100%',
  },
  imageProductDesktop: {
    width: '50%',
  },
  pointsRemainingError: {
    fontSize: 16,
    color: '#EB0043',
  },
  imageDisabled: {
    opacity: '0.5',
  },
}));

export const useProductInstructionsStyles = makeStyles(() => ({
  container: {
    backgroundColor: (props) => (props.mobile ? 'white' : '#f1f1f1'),
    padding: 40,
    textAlign: 'center',
    width: 'calc(100% + 40px)',
    marginLeft: '-20px',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 15,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 20,
  },
}));

export const useProductDocumentStyles = makeStyles(() => ({
  container: {
    marginTop: 40,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 15,
  },
  itemInput: {
    minWidth: 300,
  },
  text: {
    marginRight: (props) => (props.mobile ? 0 : 10),
    maxWidth: (props) => (props.mobile ? '95%' : ''),
  },
  documentImage: {
    marginRight: 10,
    width: '100%',
  },
  containerGrid: {
    textAlign: 'center',
  },
}));

export const useProductModalStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 0.6fr)',
    columnGap: 50,
  },
  dialog: {
    '& .MuiDialog-paper': {
      padding: '0px 20px',
      borderRadius: 10,
    },
    '& > *': {
      textAlign: 'center',
    },
  },
  button: {
    margin: '23px 0px',
  },
  title: {
    fontSize: 20,
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  image: {
    height: 70,
    width: 59,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  divider: {
    backgroundColor: '#f1f1f1',
    marginTop: 15,
  },
  titleContainer: {
    paddingLeft: 40,
    paddingRight: 40,
  },
}));

export const useProductModalImageStyles = makeStyles(() => ({
  image: {
    width: (props) => (props.mobile ? 100 : 200),
    height: (props) => (props.mobile ? 70 : 130),
    objectFit: 'cover',
  },
  skeleton: {
    width: (props) => (props.mobile ? 100 : 200),
    height: (props) => (props.mobile ? 70 : 130),
  },
}));

export const useProductModalDescriptionStyles = makeStyles(() => ({
  text: {
    marginBottom: 2,
  },
  date: {
    marginBottom: 2,
    marginTop: 10,
  },
  dateEnd: {
    marginTop: 50,
  },
}));
